import SiteSearch from "@/components/layout/site-search";
import { useSiteSearchDocuments } from "@/hooks/use-site-search-documents";
import { isSupportedLocale } from "@/i18n-locales";
import { useState } from "react";

type ConnectedSiteSearchProps = {
  locale: string;
  className?: string;
  initialQuery?: string;
  onNavigate?: () => void;
};

export default function ConnectedSiteSearch({
  locale: candidateLocale,
  className,
  initialQuery,
  onNavigate,
}: ConnectedSiteSearchProps) {
  const locale = isSupportedLocale(candidateLocale) ? candidateLocale : "it";
  const [active, setActive] = useState(Boolean(initialQuery));
  const documents = useSiteSearchDocuments(locale, active);
  return (
    <SiteSearch
      locale={locale}
      documents={documents}
      className={className}
      initialQuery={initialQuery}
      onActivate={() => setActive(true)}
      onNavigate={onNavigate}
    />
  );
}
